
const { ccclass, property } = cc._decorator;
import ModelBase from "../../../table/module/poker_table/poker_table_base_model"
import { NetMsgBlackJack } from "../../net/net_msg_data_map_blackjack";
import { BlackJack } from "../../net/proto/proto_blackjack_game";
import { Room } from "../../../table/net/proto/proto_poker_room";



@ccclass
export default class BlackJackTableModel extends ModelBase {

    constructor() {
        super()
    }
    // optional uint32 pos = 1; //pos ~= player.player_pos时表示 旁注
    // optional int32 bet_type = 2;//下注类型 0 表示 底注|旁注 1表示完美对子 2表示21+3 4续压
    // optional bool auto_follow_double = 3; //自动双倍，为false时只跟单倍 旁注有意义
    // optional bool auto_follow_right = 4;//自动跟右手，为false时只跟左手 旁注有意义
    // optional int32 bet=5;//下注金额
    send_Bet_request(pos:number,betType:number,auto_follow_double:boolean,auto_follow_right:boolean,betNum:number)
    {
        let protoData: BlackJack.IBetReq = {
            pos: pos,
            betType:betType,
            autoFollowDouble: auto_follow_double,
            autoFollowRight: auto_follow_right,
            bet: betNum,
        }
        this.sendMsg(NetMsgBlackJack.BetChip, protoData)
    }

    //落座 旁观 申请
    send_OccupySeat_request(pos: number){
        let protoData: BlackJack.IOccupySeatReq = {
            pos:pos,
        }
        this.sendMsg(NetMsgBlackJack.OccupySeat, protoData)
    }
    //双倍申请
    send_DoubleBet_request(pos: number){
        let protoData: BlackJack.IDoubleBetReq = {
            pos:pos,
        }
        this.sendMsg(NetMsgBlackJack.DoubleBet, protoData)
    }

    //分牌申请
    send_EnableRight_request(pos: number){
        let protoData: BlackJack.IEnableRightReq = {
            pos:pos,
        }
        this.sendMsg(NetMsgBlackJack.EnableRight, protoData)
    }

    //要牌申请
    send_MoreCard_request(pos:number){
        let protoData: BlackJack.IMoreCardReq = {
            pos:pos,
        }
        this.sendMsg(NetMsgBlackJack.MoreCard, protoData)
    }
   
    //停牌申请
    send_NoMoreCard_request(pos:number){
        let protoData: BlackJack.INoMoreCardReq = {
            pos:pos,
        }
        this.sendMsg(NetMsgBlackJack.NoMoreCard, protoData)
    }

     //保险申请
     send_Insurance_request(pos:number,rejected:boolean)
     {
        let protoData: BlackJack.IInsuranceReq = 
        {
            pos:pos,
            rejected:rejected,
        }
        this.sendMsg(NetMsgBlackJack.Insurance, protoData)

    
    }
    //离开房间请求
    request_leave_room(){
        let protoData: Room.ILeaveReq = {};
        this.sendMsg(NetMsgBlackJack.LeaveRoom, protoData)
    }

    //离开房间请求
    send_Bet_Finish(seatId:number){
        let protoData: BlackJack.IBetFinishReq = 
        {
            seatId:seatId
        }
        this.sendMsg(NetMsgBlackJack.BetFinish, protoData)
    }
    
    //节奏请求
    send_Ack_request(ackId:number){
        let protoData: BlackJack.IAckReq = 
        {
            ackId:ackId
        }
        this.sendMsg(NetMsgBlackJack.AckReq, protoData)
    }
}
